import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ObserverService {
  private subject: Subject<{topic: string, data: any}> = new Subject();

  public observe(topic: string): Observable<{topic: string, data: any}> {
    return this.subject.asObservable().pipe(filter(obs => {
      return topic === obs.topic;
    }));
  }

  constructor() { }

  public notify(topic: string, data?: any): void {
    this.subject.next({topic, data});
  }
}
